import { Action } from 'redux';

import { SiteUserAddUsers } from './../AppActionTypes';

export interface SiteUserAddAction extends Action {}

export function addSiteUsers(): SiteUserAddAction {
  return {
    type: SiteUserAddUsers,
  };
}
